import { util } from "../../../../../core/constants";


export const dispatchCapacityByDispatchType = {
  searchText: "Buscar ...",
  export: false,
  filter: false,
  checkbox: true,
  show: "Aun no hay capacidades que mostrar",
  iconsOfActions: [
    {
      icon: "cancel",
      tooltip: "Eliminar capacidad",
    },
    {
      icon: "edit",
      tooltip: "Editar capacidad",
      hasVisibleCondition: (element: any[]): boolean => {
        return element && element.length && element.length <= 1 ? true : false;
      },
    },
    {
      icon: "exception-days",
      tooltip: "Agregar excepción",
    },
    {
      icon: "calendar",
      tooltip: "Agregar excepción de feriados",
    },
  ],
  columns: [
    {
      title: "Tipo de despacho",
      name: "dispatchTypeCode",
      type: "string",
      class: "left",
      value: (element: any) => element.dispatchTypeCode,
    },
    /*         {
            title: 'Zona agrupada',
            name: 'clusteredZone',
            type: 'string',
            class: 'left',
            value: (element: any) => element.clusteredZone
        }, */
    {
      title: "Zona",
      name: "zone",
      type: "string",
      class: "left",
      value: (element: any) =>
        element.nameOfZones
          ? element.nameOfZones
          : element.zone
          ? element.zone.name
          : "",
    },
    {
      title: "Atributo",
      name: "attribute",
      type: "string",
      class: "left",
      value: (element: any) =>
        // element.attribute ? element.attribute.category : "",
        element.attribute && Array.isArray(element.attribute)
          ? element.attribute[0].category.includes(",")
            ? element.attribute[0].category
            : element.attribute
                .map((attribute) => attribute.category)
                .join(util.commaWithSpace)
          : "",
    },
    {
      title: "Nº Despachos",
      name: "capacityValue",
      type: "string",
      class: "left",
      value: (element: any) => element.capacityValue,
    },
    {
      title: "Rango horario",
      name: "timeRange",
      type: "string",
      class: "left",
      value: (element: any) =>
        element.timeRangeFrom != null
          ? element.timeRangeFrom + " a " + element.timeRangeTo
          : "",
    },
    {
      title: "Hora y minuto de bloqueo",
      name: "blockingTime",
      type: "string",
      class: "left",
      value: (element: any) =>
        element.blockingHour != null &&
        element.blockingMinute &&
        element.blockingMinute.id != null
          ? element.blockingHour + ":" + element.blockingMinute.value
          : element.blockingHour != null && element.blockingMinute != null
          ? element.blockingHour.toString() +
            ":" +
            element.blockingMinute.toString()
          : null,
    },
    {
      title: "Códigos Vtex",
      name: "vtexCodeList",
      type: "string",
      class: "left",
      value: (element: any) =>
        element.vtexCodeList && element.vtexCodeList.length > 0
          ? element.vtexCodeList.map((item) => item.vtexCode)
          : "",
    },
    {
      title: "Tiene excepciones",
      name: "exception",
      type: "string",
      class: "left",
      value: (element: any) =>
        element.capacityException && element.capacityException.length > 0
          ? "SI"
          : "NO",
    },
  ],
};
